<style>
  .profile-picture {
    padding: 5px;
  }

    .profile-picture img {
      height: 60px;
      width: 60px;
    }
</style>

<div class="profile-picture">
  <a *ngIf="pictureUrl && pictureUrl.length > 5">
    <img [src]="'/images/profiles/' + pictureUrl" class="profile-img img-circle m-b-xs" alt="logo">
  </a>
  <div class="stats-label text-color">
    <span class="font-extra-bold font-uppercase">{{ userFullName }}</span>
    <!-- <small *ngIf="lastLogin" title="Last Login"><br />{--{ lastLogin | date: 'short' }}</small> -->
    <small *ngIf="user.impersonated" class="text-danger" title="User impersonating current account"><br />({{ user.impersonatedByName }})</small>

    <div class="dropdown">
      <a class="dropdown-toggle" href="#" data-bs-toggle="dropdown">
        <small class="text-muted">
          <ng-container *ngFor="let role of userRoles.split(','); let last = last">
            {{ role }} <br *ngIf="!last" />
          </ng-container>
          <b class="caret"></b>
        </small>
      </a>
      <br />
      <small *ngIf="user && user.advisor" class="text-muted text-uppercase">
        {{ user.advisor?.companyGroup?.companyName || '-' }}
      </small>
      <ul class="dropdown-menu animated fadeInDown m-t-xs">
<!--        <li *ngIf="user.impersonated" class="dropdown-item"><a (click)="endImpersonation()" class="full-width">End Impersonation</a></li>-->
        <li *ngIf="user.impersonated" class="dropdown-item full-width2" (click)="endImpersonation()">End Impersonation</li>
        <li class="divider dropdown-item"></li>
        <!--<li class="dropdown-item"><a (click)="logout()" class="full-width">Logout</a></li>-->
        <li class="dropdown-item full-width2" (click)="logout()">Logout</li>
      </ul>
    </div>

    <ng-content select="[adminMode]"></ng-content>
    <ng-content select="[impersonationMode]"></ng-content>
  </div>
